import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AdvantageDatasourceService } from './services/advantage-datasource.service';

@Component({
  selector: 'app-advantage',
  templateUrl: './advantage.component.html',
  styleUrls: ['./advantage.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AdvantageDatasourceService],
})
export class AdvantageComponent {
  constructor(public advantageDatasourceService: AdvantageDatasourceService) {}

  topProductsOptions = {
    loop: true,
    nav: true,
    navText: [''],
    mouseDrag: false,
    autoplay: true,
    responsive: {
      0: {
        items: 1,
      },
    },
  };
}
